/** Small label for where a transaction came from (card CSV vs Boekhoudgemak). */

const SOURCE_LABELS: Record<string, { label: string; title: string }> = {
  boekhoudgemak: {
    label: "Bank",
    title: "Imported from Boekhoudgemak (bank account)",
  },
  ing_mastercard: {
    label: "Card",
    title: "Imported from ING credit card CSV",
  },
};

export function SourceBadge({ source }: { source?: string | null }) {
  if (!source) return null;
  const meta = SOURCE_LABELS[source] || {
    label: source,
    title: `Import source: ${source}`,
  };
  const isBank = source === "boekhoudgemak";
  return (
    <span
      className={`badge ${isBank ? "badge-source-bank" : "badge-source-card"}`}
      title={meta.title}
    >
      {meta.label}
    </span>
  );
}
